import { call, delay, fork, put, select, takeLatest } from 'redux-saga/effects';
import { CLUSTERS } from 'src/store/ActionTypes';

import * as api from 'src/store/api';

function* fetchSegments(action) {
  try {
    const { payload: query } = action;
    const segments = yield call(api.fetchSegments, query);
    yield put({
      type: CLUSTERS.FETCH_SEGMENTS_SUCCEEDED,
      payload: segments,
    });
  } catch (e) {
    yield put({
      type: CLUSTERS.FETCH_SEGMENTS_FAILED,
    });
  }
}

function* updateCluster(id, payload) {
  yield call(api.updateCluster, id, payload);
}

function* saveClusters(action) {
  try {
    const { payload } = action;
    const {
      clusters: { segments },
    } = yield select();
    if (segments.length === 1) {
      const segment = segments[0];
      const regex = new RegExp(`CLUSTERING_V\\d/${payload}$`, 'g');
      const clustersToSave = segment.clusters.filter(({ filter }) => filter.match(regex));
      if (clustersToSave.length > 0) {
        const clustersToRevert = segment.clusters.filter(({ filter }) =>
          filter.match(/CLUSTERING_V\d+\/\d+\/SELECTED/)
        );
        for (let i = 0; i < clustersToRevert.length; i += 1) {
          yield fork(updateCluster, clustersToRevert[i].id, {
            filter: clustersToRevert[i].filter.replace('/SELECTED', ''),
          });
        }
        for (let i = 0; i < clustersToSave.length; i += 1) {
          yield fork(updateCluster, clustersToSave[i].id, { filter: `${clustersToSave[i].filter}/SELECTED` });
        }
      }
      yield put({
        type: CLUSTERS.SAVE_CLUSTERING_SUCCEEDED,
      });
    }
  } catch (e) {
    yield put({
      type: CLUSTERS.SAVE_CLUSTERING_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: CLUSTERS.UNSET,
      payload: 'saveClusteringStatus',
    });
  }
}

function* editCluster(action) {
  try {
    const {
      payload: { id, payload },
    } = action;
    yield call(updateCluster, id, payload);
    yield put({
      type: CLUSTERS.EDIT_CLUSTER_SUCCEEDED,
      payload: {
        id,
        payload,
      },
    });
  } catch (e) {
    yield put({
      type: CLUSTERS.EDIT_CLUSTER_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: CLUSTERS.UNSET,
      payload: 'editClusterStatus',
    });
  }
}

function* fetchSegmentsSaga() {
  yield takeLatest(CLUSTERS.FETCH_SEGMENTS, fetchSegments);
}

function* saveClustersSaga() {
  yield takeLatest(CLUSTERS.SAVE_CLUSTERING, saveClusters);
}

function* editClusterSaga() {
  yield takeLatest(CLUSTERS.EDIT_CLUSTER, editCluster);
}

export default [fetchSegmentsSaga(), saveClustersSaga(), editClusterSaga()];
